module.exports = __webpack_public_path__ + "img/icon-1.6bb56f49.png";